import React, { useEffect, useMemo, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  emptyWorkPlanPro,
  loadWorkPlanPro,
  unassignWorkPlanPro,
} from "../../../Redux/Actions/ActionWorkPlanProduct";
import NoInternet from "../../General/NotPermission/NoInternet";
import NoData from "../../General/NoData/NoData";
import InnerLoader from "../../General/InnerLoader";
import SinglePagenation from "../../General/Pagination/SinglePagenation";
import "./ProductsAssign.css";
import MultiSelectStock from "./MultiSelectStock";

function batchDisplayForPivot(pivot, t) {
  const batch = pivot?.batch_number;
  if (batch != null && String(batch).trim() !== "") {
    return String(batch);
  }
  return t("work_plan_stock_no_batch");
}

function GroupedBatchLines({ lines, t }) {
  return (
    <div className="product_stock_details">
      {lines.map((pp, idx) => {
        const pivot = pp.pivot;
        const batchText = batchDisplayForPivot(pivot, t);
        const qty =
          pivot?.quantity != null && pivot?.quantity !== ""
            ? pivot.quantity
            : "—";
        const lineKey =
          pivot?.id != null && pivot?.id !== ""
            ? `wpp-${pivot.id}`
            : `line-${pp.id}-${idx}`;

        return (
          <div key={lineKey} className="product_stock_line">
            <div className="product_stock_line_main">
              {t("work_plan_stock_batch_qty_line", {
                batch: batchText,
                qty,
              })}
            </div>
          </div>
        );
      })}
    </div>
  );
}

function groupWorkPlanProducts(items) {
  const map = new Map();
  for (const pp of items) {
    const pid = pp.id;
    if (!map.has(pid)) {
      map.set(pid, { meta: pp, lines: [] });
    }
    map.get(pid).lines.push(pp);
  }
  return Array.from(map.values());
}

function ProductsAssign({ langmiamed, t }) {
  const [openInternet, setopenInternet] = useState(false);
  const [open, setopen] = useState(false);
  let navigate = useNavigate();
  let dispatch = useDispatch();
  let { id } = useParams();
  const [Load, setLoad] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const WorkPlanPro = useSelector(
    (state) => state.Product_WorkPlan.WorkPlanPro
  );
  const loadingWorkPlanPro = useSelector(
    (state) => state.Product_WorkPlan.loadingWorkPlanPro
  );

  const groupedProducts = useMemo(
    () => groupWorkPlanProducts(WorkPlanPro),
    [WorkPlanPro]
  );

  useEffect(() => {
    dispatch(loadWorkPlanPro(id, navigate));
    return () => {
      dispatch(emptyWorkPlanPro());
    };
  }, []);

  const [pageNumber, setPageNumber] = useState(0);
  const productPerPage = 12;
  const pagesVisited = pageNumber * productPerPage;
  const displayGroups = groupedProducts.slice(
    pagesVisited,
    pagesVisited + productPerPage
  );
  const pageCount = Math.ceil(groupedProducts.length / productPerPage);

  const changePage = ({ selected }) => {
    setPageNumber(selected);
  };
  const handleCheckboxChange = (e, productId) => {
    const isChecked = e.target.checked;
    setSelectedProducts((prevFeatures) => {
      if (isChecked) {
        return [...prevFeatures, { id: productId }];
      } else {
        return prevFeatures.filter((proId) => proId.id !== productId);
      }
    });
  };
  const print = (event) => {
    event.preventDefault();
    dispatch(
      unassignWorkPlanPro(
        id,
        selectedProducts,
        navigate,
        setopenInternet,
        setLoad
      )
    );
    setSelectedProducts([]);
  };
  const openAddNew = () => {
    setopen(true);
  };

  const reversedPage = displayGroups.slice().reverse();

  return (
    <>
      {open && (
        <MultiSelectStock
          work_plan_id={id}
          t={t}
          langmiamed={langmiamed}
          open={open}
          setOpen={setopen}
        />
      )}
      <div className="btn_product_assign">
        <div
          onClick={print}
          className={`btn_assign1 ${
            langmiamed == "ar" ? "margin_left_20" : "margin_right_20"
          }`}
        >
          {Load ? t("Loading ...") : `${t("unassign")}`}
        </div>
        <div className="btn_assign1" onClick={openAddNew}>
          {t("assign")}
        </div>
      </div>
      <div className="allproducts" dir={langmiamed == "ar" ? "rtl" : "ltr"}>
        {loadingWorkPlanPro == false ? (
          reversedPage.map((group) => {
            const pp0 = group.meta;
            const lines = group.lines;
            const totalPlanned = lines.reduce(
              (sum, p) => sum + Number(p.pivot?.quantity ?? 0),
              0
            );
            const hasMedia = pp0.media_urls && pp0.media_urls.length !== 0;

            return (
              <div
                key={`product-${pp0.id}`}
                className="oneproduct"
                dir={langmiamed == "ar" ? "rtl" : "ltr"}
              >
                {hasMedia ? (
                  <>
                    <div
                      className="img_product"
                      style={{
                        backgroundImage:
                          " linear-gradient(rgba(53, 37, 37, 0.0), rgba(0, 0, 0, 0.0)), url(" +
                          pp0.media_urls[0].url +
                          ")",
                      }}
                    >
                      <input
                        className="checkbox_pro"
                        type="checkbox"
                        onChange={(e) => handleCheckboxChange(e, pp0.id)}
                      />
                    </div>
                    <div className="product_info">
                      <div className="withQuantity">
                        <h5 style={{ color: pp0.color || "black" }}>
                          {pp0.name}
                        </h5>
                        <span
                          style={{ backgroundColor: pp0.color || "black" }}
                          className={`quantityPro ${
                            langmiamed == "ar"
                              ? "margin_right_10"
                              : "margin_left_10"
                          }`}
                          title={t("work_plan_stock_total_planned")}
                        >
                          {totalPlanned}
                        </span>
                      </div>
                      <span>{pp0.description}</span>
                      <span>{pp0.internal_reference}</span>
                      <span>
                        {pp0.category_name} / {pp0.product_type}
                      </span>
                      <GroupedBatchLines lines={lines} t={t} />
                    </div>
                  </>
                ) : (
                  <>
                    <div
                      className="img_product"
                      style={{ backgroundColor: "#d3d0d0a7" }}
                    >
                      <input
                        className="checkbox_pro"
                        type="checkbox"
                        onChange={(e) => handleCheckboxChange(e, pp0.id)}
                      />
                    </div>
                    <div className="product_info">
                      <div className="withQuantity">
                        <h5 style={{ color: pp0.color || "black" }}>
                          {pp0.name}
                        </h5>
                        <span
                          style={{ backgroundColor: pp0.color || "black" }}
                          className={`quantityPro ${
                            langmiamed == "ar"
                              ? "margin_right_10"
                              : "margin_left_10"
                          }`}
                          title={t("work_plan_stock_total_planned")}
                        >
                          {totalPlanned}
                        </span>
                      </div>
                      <span>{pp0.description}</span>
                      <span>{pp0.internal_reference}</span>
                      <span>
                        {pp0.category_name} / {pp0.product_type}
                      </span>
                      <GroupedBatchLines lines={lines} t={t} />
                    </div>
                  </>
                )}
              </div>
            );
          })
        ) : (
          <div className="div_loadd">
            <InnerLoader />
          </div>
        )}
        {loadingWorkPlanPro == false && WorkPlanPro.length == 0 && <NoData />}
        <SinglePagenation pageCount={pageCount} changePage={changePage} />
      </div>
      {openInternet && (
        <NoInternet open={openInternet} setOpen={setopenInternet} />
      )}
    </>
  );
}

export default ProductsAssign;
